import { baseApi } from 'services/api';
import { API_BASE_URL, API_VERSION } from 'constants/common';
import {
  GetEstimateSettingsResponse,
  UpdateEstimateRemindersResponse,
  UpdateEstimateSettingReminderTogglePayload,
  UpdateEstimateSettingsPayload,
  UpdateEstimateSettingsRemindersPayload,
  UpdateEstimateSettingsRemindersResponse,
  UpdateEstimateSettingsResponse
} from './estimateSetting.model';

export const estimateSettingsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getEstimateSettings: builder.query<GetEstimateSettingsResponse, { teamId: number }>({
      query: ({ teamId }) => ({
        url: `${API_BASE_URL.ESTIMATE_MANAGER}/${API_VERSION.V1}/teams/${teamId}/estimates/settings`,
        method: 'GET'
      }),
      extraOptions: {
        failure: 'Failed to fetch estimate settings',
        showToast: false
      }
    }),

    updateEstimateSettingsExpiry: builder.mutation<UpdateEstimateSettingsResponse, UpdateEstimateSettingsPayload>({
      query: ({ teamId, expiryPeriod, expiryDuration }) => ({
        url: `${API_BASE_URL.ESTIMATE_MANAGER}/${API_VERSION.V1}/teams/${teamId}/estimates/settings/expiry`,
        method: 'PATCH',
        body: { expiryPeriod, expiryDuration }
      }),
      extraOptions: {
        failure: 'Failed to update estimate expiry period',
        showToast: true
      }
    }),

    updateEstimateSettingReminderToggle: builder.mutation<
      UpdateEstimateRemindersResponse,
      UpdateEstimateSettingReminderTogglePayload
    >({
      query: ({ teamId, remindersEnabled }) => ({
        url: `${API_BASE_URL.ESTIMATE_MANAGER}/${API_VERSION.V1}/teams/${teamId}/estimates/settings/reminders/toggle
`,
        method: 'PATCH',
        body: { remindersEnabled }
      }),
      extraOptions: {
        failure: 'Failed to update estimate reminders',
        showToast: true
      }
    }),

    updateEstimateSettingRemindersList: builder.mutation<
      UpdateEstimateSettingsRemindersResponse,
      UpdateEstimateSettingsRemindersPayload
    >({
      query: ({ teamId, reminders }) => ({
        url: `${API_BASE_URL.ESTIMATE_MANAGER}/${API_VERSION.V1}/teams/${teamId}/estimates/settings/reminders`,
        method: 'PUT',
        body: { reminders }
      }),
      extraOptions: {
        success: 'Estimate reminders settings updated successfully!',
        failure: 'Failed to update estimate reminders settings',
        showToast: true
      }
    })
  })
});

export const {
  useGetEstimateSettingsQuery,
  useLazyGetEstimateSettingsQuery,
  useUpdateEstimateSettingsExpiryMutation,
  useUpdateEstimateSettingReminderToggleMutation,
  useUpdateEstimateSettingRemindersListMutation
} = estimateSettingsApi;
